// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-panel {
    padding: 2rem;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    max-width: 960px;
    margin: auto;
}

.security-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
    margin-top: 2rem;
}

.form-group {
    display: flex;
    flex-direction: column;
}

    .form-group label {
        font-weight: bold;
        margin-bottom: 0.5rem;
    }

input[type="file"] {
    margin-top: 4px;
}

textarea {
    resize: vertical;
    font-family: inherit;
    padding: 10px;
}

.full-width {
    grid-column: span 2;
}
.review-card {
    background: #fff;
    border: 1px solid #ccc;
    padding: 18px 24px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}

.review-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
    margin-top: 10px;
}

.step5-subtext {
    font-size: 15px;
    color: #555;
    margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PreArrival/Step5SecurityClearance.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;IAEI;QACI,iBAAiB;QACjB,qBAAqB;IACzB;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".step-panel {\n    padding: 2rem;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n    max-width: 960px;\n    margin: auto;\n}\n\n.security-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 20px;\n    margin-top: 2rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n    .form-group label {\n        font-weight: bold;\n        margin-bottom: 0.5rem;\n    }\n\ninput[type=\"file\"] {\n    margin-top: 4px;\n}\n\ntextarea {\n    resize: vertical;\n    font-family: inherit;\n    padding: 10px;\n}\n\n.full-width {\n    grid-column: span 2;\n}\n.review-card {\n    background: #fff;\n    border: 1px solid #ccc;\n    padding: 18px 24px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.05);\n}\n\n.review-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 12px;\n    margin-top: 10px;\n}\n\n.step5-subtext {\n    font-size: 15px;\n    color: #555;\n    margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
